module.exports = __webpack_public_path__ + "img/title-hk.61100d38.png";